import './eventsblock.less'

import {Icon} from '@codeurs/front'
import React from 'react'
import {ImageOrSvgType, LinkType, WysiwygType} from 'types'
import {Link} from 'util/link'
import {slugify} from 'util/slugify'
import {style} from 'util/style'
import {Title} from 'views/layout/title'
import {Theme} from 'views/theme'

const styles = style('eventsblock', ['card'])

export type EventsblockType = {
	title: string
	id: string
	greyed_out: boolean
	events?: Array<{
		logo?: ImageOrSvgType
		color: string
		date: string
		location: string
		description: WysiwygType
		link: LinkType
	}>
}

export const Eventsblock: React.FC<EventsblockType> = ({
	title,
	greyed_out,
	events = []
}) => {
	if (!events || events.length === 0) return null

	return (
		<div id={slugify(title)} className={styles()}>
			<Theme.Container>
				<Title title={title} className={styles('title')} />
				<div className={styles('items')}>
					{events.map((event, i) => (
						<div className={styles('items-item')} key={i}>
							<EventCard event={event} greyed_out={greyed_out} />
						</div>
					))}
				</div>
			</Theme.Container>
		</div>
	)
}

const EventCard: React.FC<{
	event: EventsblockType['events'][number]
	greyed_out: boolean
}> = ({event, greyed_out}) => {
	if (!event?.date && !event?.location && !event?.description && !event?.link)
		return null

	return (
		<div
			className={styles.card().mod({greyed_out})}
			style={{borderColor: event?.color}}
		>
			{event.logo && (
				<Link href={event.link?.url} className={styles.card('logo')}>
					<img src={fileOrImagePath(event.logo)} alt="Logo ITF" />
				</Link>
			)}
			{(event.date || event.location) && (
				<div className={styles.card('iconlabels')}>
					{event.date && (
						<div className={styles.card('iconlabels-item')}>
							<span className={styles.card('iconlabels-item-icon')}>
								<Icon icon="calendar" />
							</span>
							<div>{event.date}</div>
						</div>
					)}
					{event.location && (
						<div className={styles.card('iconlabels-item')}>
							<span className={styles.card('iconlabels-item-icon')}>
								<Icon icon="location" />
							</span>
							<div>{event.location}</div>
						</div>
					)}
				</div>
			)}
			{event.description && (
				<div className={styles.card('description')}>
					<Theme.Wysiwyg mod="inherit">{event.description}</Theme.Wysiwyg>
				</div>
			)}
			{event.link?.url && (
				<Theme.Button href={event.link.url} mod={['gradient']}>
					<Theme.ButtonText>
						{event.link.description || event.link.title}
					</Theme.ButtonText>
					<Theme.ButtonIcon icon="arrow-right" />
				</Theme.Button>
			)}
		</div>
	)
}

const fileOrImagePath: (ImageOrSvgType) => string = input =>
	input && (input.src || input.url)
